import { ChevronRight } from 'lucide-react';
import { AuthImg, money } from './fuelUtils';
import { AI, STATUS } from './SubCard';

const nf = (n) => Number(n || 0).toLocaleString('nl-BE', { maximumFractionDigits: 2 });

export function SubsTable({ rows, onOpen }) {
  const th = 'px-3 py-2 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500 whitespace-nowrap';
  const td = 'px-3 py-2 whitespace-nowrap';
  return (
    <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-x-auto" data-testid="fuel-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 dark:bg-slate-800/60 sticky top-0">
          <tr>
            <th className={th} /><th className={th}>Tarih</th><th className={th}>Şoför</th><th className={th}>Plaka</th><th className={th}>Durum</th>
            <th className={th}>Fiş</th><th className={th}>Kart firması</th><th className={`${th} text-right`}>Km</th>
            <th className={`${th} text-right`}>Litre</th><th className={`${th} text-right`}>Tutar</th><th className={th}>Not</th><th className={th} />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const [al, acls] = AI[r.ai_status] || AI.idle;
            const [sl, scls] = STATUS[r.status] || STATUS.pending;
            const d = new Date(r.created_at);
            return (
              <tr key={r.id} onClick={() => onOpen(r.id)} className="border-t border-slate-100 dark:border-slate-800 hover:bg-orange-50/60 dark:hover:bg-slate-800/40 cursor-pointer transition-colors" data-testid={`fuel-sub-row-${r.id}`}>
                <td className="px-3 py-1.5"><div className="h-10 w-8 rounded overflow-hidden bg-slate-100">{r.images?.[0] && <AuthImg src={`/fuel-submissions/${r.id}/images/${r.images[0].id}`} className="h-full w-full object-cover object-top" />}</div></td>
                <td className={`${td} tabular-nums`}><div className="font-semibold">{d.toLocaleDateString('nl-BE')}</div><div className="text-[11px] text-slate-500">{d.toLocaleTimeString('nl-BE', { hour: '2-digit', minute: '2-digit' })}</div></td>
                <td className={`${td} font-semibold max-w-[200px] truncate`}>{r.employee_name}</td>
                <td className={td}>{r.plate ? <span className="rounded-[4px] bg-white text-rose-700 border-2 border-rose-700 px-1.5 text-[11px] font-black tracking-wider tabular-nums">{r.plate}</span> : <span className="text-slate-400">—</span>}</td>
                <td className={td}><div className="flex gap-1"><span className={`text-[10px] font-bold rounded-full px-2 py-0.5 ${scls}`}>{sl}</span><span className={`text-[10px] font-bold rounded-full px-2 py-0.5 border border-slate-200 ${acls}`}>{al}</span></div></td>
                <td className={`${td} tabular-nums text-center`}>{r.image_count}</td>
                <td className={`${td} text-xs`}>{r.card_companies?.join(', ') || <span className="text-slate-400">—</span>}</td>
                <td className={`${td} text-right tabular-nums`}>{r.km_driver != null ? nf(r.km_driver) : '—'}</td>
                <td className={`${td} text-right tabular-nums font-semibold`}>{nf(r.liters)} L</td>
                <td className={`${td} text-right tabular-nums font-black text-orange-600`}>{money(r.total)}</td>
                <td className="px-3 py-2 text-xs italic text-slate-500 max-w-[220px] truncate" title={r.note || ''}>{r.note || ''}</td>
                <td className="px-2"><ChevronRight className="h-4 w-4 text-slate-300" /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
